import React, { useRef, useState } from "react";
import BannerSegmentOne from "Common/Components/EditableViews/BannerSegmentOne";
import BannerSegmentTwo from "Common/Components/EditableViews/BannerSegmentTwo";
import ScrollSegment from "Common/Components/EditableViews/ScrollSegment";
import VideoSegment from "Common/Components/EditableViews/VideoSegment";
import NumberScrollSegment from "Common/Components/EditableViews/NumberScrollSegment";
import AwardSegment from "Common/Components/EditableViews/AwardSegment";
import SolutionSegment from "Common/Components/EditableViews/SolutionSegment";
import CodeSegments from "Common/Components/EditableViews/CodeSegments";
import BlogFeatures from "Common/Components/EditableViews/BlogFeatures";
import collapseIcon from "../../images/Collapse.svg"; 
import expandIcon from "../../assets/images/down-arrow.png"; 
import DescriptionSegments from "Common/Components/EditableViews/DescriptionSegment";
import ValueSegment from "Common/Components/EditableViews/ValueSegment";
import ContactUsSegment from "Common/Components/EditableViews/ContactUsSegment";
import FaqSegment from "Common/Components/EditableViews/FaqSegments";
import TwoColumnSegment from "Common/Components/EditableViews/TwoColumnSegments";
import TwoColumnScroll from "Common/Components/EditableViews/TwoColumnScroll";
import PressReleaseSegment from "Common/Components/EditableViews/PressReleaseSegment";
import PeopleSegments from "Common/Components/EditableViews/PeopleSegments";
import NewsSegment from "Common/Components/EditableViews/NewsSegment";
import SplitSegment from "Common/Components/EditableViews/SplitSegment";
import PodcastSegment from "Common/Components/EditableViews/PodcastSegment";
import CollectionSegment from "Common/Components/EditableViews/CollectionSegment";
import NewsLetterSegment from "../../Common/Components/EditableViews/NewsLetterSegment";
import ExperienceSegment from "Common/Components/EditableViews/ExperienceSegment";
import CookiesSegments from "Common/Components/EditableViews/CookiesSegment";
import _ from 'lodash';


const EditableView = ({
  segmentType,
  loader,
  setLoader,
  handleshowSagment,
  segment_id,
  data,
  pageId,
  collapse,
  index,
  handleDelete,
  pageType,
  isEditable,
  versionData = {
    is_edit: false,
  },
  toggleVisiblity = null,
  moveCard
}) => {
  

  // console.log("EditableView", segmentType, data._id, data, versionData);
  // console.log("EditableView",segmentType, data._id, data, versionData);
  switch (segmentType) {
    case "home_banner_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
              <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Home Banner Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <BannerSegmentOne
                pageType={pageType}
                pageId={pageId}
                loader={loader}
                setLoader={setLoader}
                handleDelete={handleDelete}
                data={versionData ? versionData : data}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "banner_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer "
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Banner Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <BannerSegmentTwo
                pageType={pageType}
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                handleDelete={handleDelete}
                data={versionData ? versionData : data}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "blog_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Blog Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <BlogFeatures
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "award_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Award Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <AwardSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "video_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Video Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <VideoSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                segmentId={data?._id}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "scroll_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Scroll Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <ScrollSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                segmentId={data?._id}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );

    case "number_scroll_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Number Scroll Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <NumberScrollSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                segmentId={data?._id}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );

    case "code_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Code Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <CodeSegments
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                pageType={pageType}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );

    case "solution_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Solution Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <SolutionSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                segmentId={data?._id}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "description_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Description Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <DescriptionSegments
                pageType={pageType}
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                segmentId={data?._id}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "value_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Value Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <ValueSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "contact_us_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                ContactUs Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <ContactUsSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "faq_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Faqs Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <FaqSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                segmentId={data?._id}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "twocolumn_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Two Column Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <TwoColumnSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "twocolumnscroll_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Two Column Scroll Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <TwoColumnScroll
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "pressrelease_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Press Release Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <PressReleaseSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "people_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                People Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <PeopleSegments
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "podcast_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Podcast Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <PodcastSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "news_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                News Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <NewsSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                segmentId={data?._id}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "split_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Split Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <SplitSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "collection_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Collection Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <CollectionSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
                segmentId={data?._id}
              />
            )}
          </div>
        </div>
      );
    case "newsletter_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                NewsLetter Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <NewsLetterSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "experience_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Experience Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <ExperienceSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
                segmentId={data?._id}
              />
            )}
          </div>
        </div>
      );
    case "cookies_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer"
            >
                            <img
      src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">
                Cookies Segment{" "}
                {`${versionData && versionData.is_edit ? "(edited)" : ""}`}
              </p>
            </div>
            {collapse.some((item) => item === index) && (
              <CookiesSegments
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={versionData ? versionData : data}
                handleDelete={handleDelete}
                versionData={versionData ? data : null}
                isEditable={isEditable}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default EditableView;
